import React, { useEffect } from 'react'

function PushwooshInit() {


useEffect(() => {
    // Only run on client
    const script = document.createElement("script");
    script.src = "https://cdn.pushwoosh.com/webpush/v3/pushwoosh-web-notifications.js";
    script.async = true;    
    script.onload = () => {
        console.log("✅ Pushwoosh SDK script loaded");
      
        window.Pushwoosh = window.Pushwoosh || [];
      
        // Initialize Pushwoosh
        window.Pushwoosh.push(["init", {
          logLevel: 'error',
          applicationCode: process.env.NEXT_PUBLIC_PUSHWOOSH_WEB_CODE,
          safariWebsitePushID: 'web.web-dev.thelallantop.com',
          // defaultNotificationTitle: 'Pushwoosh LT TEST',
          // defaultNotificationImage: 'https://static.thelallantop.com/images/post/1695637095493_lallantop-logo_(1).webp?width=120',
          autoSubscribe: true, // ✅ enable auto subscribe
          serviceWorkerUrl: `pushwoosh/pushwoosh-service-worker.js`,
        }]);
      
        // Handle successful subscription
        window.Pushwoosh.push(["onSubscribe", function(api) {
          console.log("✅ User successfully subscribed");
      
          // api.getHWID().then(hwid => {
          //   console.log("📡 HWID:", hwid);
          // });
      
          // api.getPushToken().then(token => {
          //   console.log("🔑 Push Token:", token);
          // });
        }]);
      
        console.log('Notification permission: outer');
        
        // Request notification permission
        // Notification.requestPermission().then(permission => {
        //   console.log(`🔔 Notification permission: inner ${permission}`);
        //   if (permission === "granted") {
        //     console.log("✅ User clicked allow — autoSubscribe will now handle registration");
        //   } else {
        //     console.warn("🚫 User denied notification permission");
        //   }
        // }).catch(err => {
        //   console.error("❌ Error requesting notification permission", err);
        // });
      };
      
    
    document.head.appendChild(script);
},[])



  return (
    <>  
    </>
  )
}

export default PushwooshInit
